import { apiSlice } from '../app/api/apiSlice';

export const dropBuyApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    dropBuy: builder.query({
      query: ()=> 'dropbuy',
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg)=>[
        {type:'DropBoy', id: 'LIST'},
      ]
    }),
    urlRedirect: builder.query({
      query: (queryParams) => ({
        url: `dropbuy/urlredirect?${new URLSearchParams(queryParams).toString()}`,
      }),
    }),
  })
})

export const { useDropBuyQuery, useLazyUrlRedirectQuery } = dropBuyApi;
